import { render, staticRenderFns } from "./KSRUploadDocuments.vue?vue&type=template&id=5b4ebf3a&"
import script from "./KSRUploadDocuments.vue?vue&type=script&lang=js&"
export * from "./KSRUploadDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports